import ValueInterface, { SerializedValueType } from "./ValueInterface"

export default class SubtractionValue implements ValueInterface {
  constructor(
    private readonly minuend: ValueInterface,
    private readonly subtrahend: ValueInterface,
  ) {}

  public toString(): string {
    return `${this.minuend} - ${this.subtrahend}`
  }

  public normalize(): number {
    return this.minuend.normalize() - this.subtrahend.normalize()
  }

  public clone(): SubtractionValue {
    return new SubtractionValue(this.minuend, this.subtrahend)
  }

  public toJSON(): SerializedValueType {
    return {
      type: "subtraction",
      payload: {
        minuend: this.minuend.toJSON(),
        subtrahend: this.subtrahend.toJSON(),
      },
    }
  }
}
